import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import MapImageLayer from "@arcgis/core/layers/MapImageLayer";
export function getFeatureLayer(layer) {
    let featureLayer = new FeatureLayer({
        url: layer.url,
        id: layer.layerId,
        outFields: ["*"]
    });
    return featureLayer;
}
export function getImageLayer(layer) {
    let ImageLayerLayer = new MapImageLayer({
        // url: layer.url,
        // id: layer.layerId,
        // title: layer.title
        ...layer
    });
    return ImageLayerLayer;
}
export function getLayerByLayerId(mapView, id) {
    let layer = mapView.map.layers.items.find(function (l) {
        return l.id === id;
    });
    return layer;
}
